import React, { useEffect, useRef, useState } from 'react';
import { calculateNumberOfRows, MAXIMUM_NUMBER_OF_ROWS } from '../scroller-utils';
import CountryIcon from './CountryIcon';
import IconsScroller from './IconsScroller';

function CountrySelector(props) {
    function changeCountry(countryId) {
        props.changeCountry(countryId);
    }
    const countryIcons = props.countryList.map(function(country) {
        return (
            <CountryIcon key={country.id}
                         {...country}
                         desc={country.descrizione}
                         count={country.tournamentsCount}
                         selected={props.selected === country.id}
                         changeCountry={changeCountry}
            />
        );
    });

    const el = useRef(null);
    const [scrollerEnabled, setScrollerEnabled] = useState(false);
    useEffect(() => {
        if (!props.forceRows && el.current != null) {
            let numberOfRows = calculateNumberOfRows(el.current);
            if (numberOfRows > 1) {
                setScrollerEnabled(true);
            } else if(numberOfRows !== MAXIMUM_NUMBER_OF_ROWS) { // Chiudo lo scroller solo se  numberOfRows!=maximumNumberOfRows
                setScrollerEnabled(false);
            }
        }
    }, [props.forceRows, countryIcons]);

    return (
        <div className="container-slider-icone-paese mb-2 overflow-unset has-icons-container-no-wrap">
            <div className="containerElementiDropdown slider-icone-paese horiz-sc icons-container icons-container-no-wrap" ref={el}>
                {countryIcons}
            </div>
            {scrollerEnabled &&
                <IconsScroller buttons={countryIcons} iconsContainer={el.current} />
            }
        </div>
    );
}

export default CountrySelector;
